var surround = require('./surround');

module.exports = function quote(str, quoteChar) {
  return surround(str, quoteChar || '"');
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/underscore.string/quote.js
// module id = 835
// module chunks = 0